import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
// import ProductPage from './pages/ProductPage';
// import Contact from './pages/Contact';
import Quote from './components/QuoteForm';
import Header from './components/Header';
import Footer from './components/Footer';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ProductPage from './pages/ProductPage';
export const PHONE_NUMBER = '+1 905-246-0112';
export const EMAIL_ADDRESS = 'inquiry@paperforless.ca';
export const SERVICE_ID = 'service_d7kzv3g';
export const TEMPLATE_ID = 'template_h66g7zi';
export const USER_ID = 'CuUZt7wSMyoRaPIZw';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products/:id" element={<ProductPage />} />
        {/* <Route path="/" element={<ProductPage />} /> */}
        {/* <Route path="/contact" element={<Contact />} /> */}
        <Route path="/quote" element={<Quote/>} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
